import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { COOKIE_CONSENT_KEY, initGA } from '../lib/analytics';
import { getLangFromPath } from '../i18n/langs';

const TEXTS = {
  es: { text: 'Usamos cookies de análisis (Google Analytics) para saber cómo se usa la web y mejorarla. Solo se activan si las aceptas.', accept: 'Aceptar', reject: 'Rechazar' },
  ca: { text: "Fem servir galetes d'anàlisi (Google Analytics) per saber com s'utilitza el web i millorar-lo. Només s'activen si les acceptes.", accept: 'Acceptar', reject: 'Rebutjar' },
  en: { text: 'We use analytics cookies (Google Analytics) to understand how the website is used and improve it. They are only enabled if you accept them.', accept: 'Accept', reject: 'Reject' },
  fr: { text: "Nous utilisons des cookies d'analyse (Google Analytics) pour comprendre l'utilisation du site et l'améliorer. Ils ne sont activés que si vous les acceptez.", accept: 'Accepter', reject: 'Refuser' },
};


const CookiesBanner: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const tx = TEXTS[getLangFromPath(location.pathname)];

  useEffect(() => {
    // Check if user has already given consent
    let hasConsent: string | null = null;
    try { hasConsent = localStorage.getItem(COOKIE_CONSENT_KEY); } catch { /* sin almacenamiento */ }
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try { localStorage.setItem(COOKIE_CONSENT_KEY, 'true'); } catch { /* sin almacenamiento */ }
    initGA();
    setIsVisible(false);
  };

  const handleReject = () => {
    try { localStorage.setItem(COOKIE_CONSENT_KEY, 'false'); } catch { /* sin almacenamiento */ }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-black/95 text-white p-4 z-50">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm">
            {tx.text}
          </p>
        </div>
        <div className="flex items-center gap-4">
          <button
            onClick={handleAccept}
            className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-2 rounded-lg font-medium transition-colors"
          >
            {tx.accept}
          </button>
          <button
            onClick={handleReject}
            className="border border-white/60 hover:border-yellow-500 hover:text-yellow-500 text-white px-4 py-2 rounded-lg font-medium transition-colors"
          >
            {tx.reject}
          </button>
          <button
            onClick={() => setIsVisible(false)}
            className="text-white hover:text-yellow-500 transition-colors"
            aria-label="Cerrar banner de cookies"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiesBanner;